import styled from 'styled-components/macro'
import { sizes } from '../../../theme'
import { rem } from 'polished'

export const IconButton = styled.div`
  display: inline-flex;
  padding: ${rem(sizes.size2)};
  cursor: pointer;
`
